import { ShowTemplateType } from "enums/ShowTemplates";

export interface InputContentVariable {
  header: string,
  title: string,
  description: string[],
  news: string,
  upperCaseText: string,
  boldUpperCaseText: string,
  hypePhrase: string
}

export interface ShowTemplate {
  showTemplateType: ShowTemplateType,
  templateId?: number,
  inputContentVariablesJson: string,
  subject: string

}

export type ShowTemplates = ShowTemplate[];

export const emptyInputContentVariable: InputContentVariable = {
  header: "",
  title: "",
  description: ["", ""],
  news: "",
  upperCaseText: "",
  boldUpperCaseText: "",
  hypePhrase: "",
}

export interface TemplateInterface {
  id?: number;
  name?: string;
  text?: string;
  subject?: string;
  fromEmail?: string;
  templateSeparator?: string;
  notificationType?: string;
  hasInputContentVariables?: boolean;
  createAt?: string;
  createdBy?: string;
  updateAt?: string;
  updateBy?: string;
  deletedAt?: string;
  deletedBy?: string;
}

export interface TemplateSimplifiedInterface {
  id: number;
  name: string;
}

export type SingleTemplate = TemplateInterface | null;
export type Templates = TemplateInterface[] | null;
